"use strict";

const PageTitle = angular
    .module("PageTitle", [])
    .directive("pageTitle", ["$state", "$rootScope", "$timeout", pageTitleDirective]);

function pageTitleDirective($state, $rootScope, $timeout) {
    return {
        restrict: "A",
        link: function (scope, element) {
            const listener = function (event, toState) {
                let title = "Empower",
                    appendEmpowerTitle = " | Empower";

                if (toState.data && toState.data.title) {
                    if (toState.data.title === "dynamic") {
                        const pageName = $state.params.name
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            });
                        title = pageName + appendEmpowerTitle;
                    } else {
                        title = toState.data.title + appendEmpowerTitle;
                    }
                }

                $timeout(
                    function () {
                        element.text(title);
                    },
                    0,
                    false
                );
            };

            $rootScope.$on("$stateChangeSuccess", listener);
        }
    };
}

export default PageTitle;
